export default {
  "content": "<path d=\"M11 5.5H5.5v13h13V14h2v5.5a1 1 0 01-1 1h-15a1 1 0 01-1-1v-15a1 1 0 011-1H11v2z\" fill=\"#7B61FF\"/><path d=\"M18.83 5.3l3.015-1.674.97 1.748L19.89 7l2.926 1.626-.97 1.748-3.015-1.675V12h-2V8.7l-3.015 1.674-.97-1.748L15.77 7l-2.926-1.626.97-1.748 3.015 1.675V2h2v3.3z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};